module.exports = new __parcel__URL__("task.ce7fec8e.svg").toString();